import type { OrderStatus } from '@auto-oms/shared/types/order';

const STYLE: Record<OrderStatus, { label: string; className: string }> = {
  COLLECTED:         { label: '수집됨',      className: 'bg-ink-100 text-ink-700' },
  PO_SENT:           { label: '발주 발송',   className: 'bg-info-soft text-info-ink' },
  TRACKING_RECEIVED: { label: '송장 수신',   className: 'bg-[#EDE9FE] text-[#5B21B6]' },
  SHIPPED_TO_MALL:   { label: '몰 등록 중',  className: 'bg-[#E0F2FE] text-[#075985]' },
  DONE:              { label: '완료',        className: 'bg-brand-50 text-brand-700' },
  FAILED_PO:         { label: '발주 실패',   className: 'bg-danger-soft text-danger-ink' },
  FAILED_PARSE:      { label: '파싱 실패',   className: 'bg-danger-soft text-danger-ink' },
  FAILED_SHIP:       { label: '출고 실패',   className: 'bg-danger-soft text-danger-ink' },
};

export function StatusBadge({ status }: { status: OrderStatus }) {
  const s = STYLE[status];
  return <span className={`badge badge-dot ${s.className}`}>{s.label}</span>;
}
